import React from 'react';
import { ShieldCheck, Sprout, TrendingUp, Leaf } from 'lucide-react';
import { whyApnaFarm } from '../../data/mock';
import Reveal from './Reveal';

const iconMap = { ShieldCheck, Sprout, TrendingUp, Leaf };

const WhySection = () => {
  const { eyebrow, title, description, stats, pillars } = whyApnaFarm;

  return (
    <section id="why" className="py-20 md:py-28 bg-white" data-testid="why-section">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        {/* Header */}
        <Reveal className="text-center mb-14 md:mb-16 max-w-2xl mx-auto">
          <p className="text-[#0C6951] text-sm font-bold tracking-[0.15em] uppercase mb-4">
            {eyebrow}
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-[#004534] mb-5 leading-tight">
            {title}
          </h2>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed">
            {description}
          </p>
        </Reveal>

        {/* Stat strip */}
        <Reveal className="mb-16" delay={80}>
          <div className="grid grid-cols-2 lg:grid-cols-4 rounded-3xl overflow-hidden border border-[#004534]/10 bg-gradient-to-br from-[#f8fdf5] to-white">
            {stats.map((s, i) => (
              <div
                key={i}
                className="text-center py-8 px-4 border-[#004534]/10 [&:not(:nth-child(2n))]:border-r lg:[&:not(:last-child)]:border-r [&:nth-child(-n+2)]:border-b lg:[&:nth-child(-n+2)]:border-b-0"
              >
                <p className="text-4xl md:text-5xl font-black text-[#004534] leading-none">
                  {s.value}
                  <span className="text-[#0C6951] text-2xl md:text-3xl align-top ml-0.5">{s.suffix}</span>
                </p>
                <p className="text-gray-500 text-xs md:text-sm mt-3">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        {/* Pillars */}
        <div className="grid sm:grid-cols-2 gap-5 md:gap-6">
          {pillars.map((p, i) => {
            const Icon = iconMap[p.icon] || ShieldCheck;
            return (
              <Reveal key={i} delay={i * 90}>
                <div className="group flex gap-5 bg-white rounded-2xl p-6 md:p-7 border border-gray-100 shadow-sm hover:shadow-lg hover:border-[#c4e538]/50 transition-all duration-300 h-full">
                  <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#004534]/10 flex items-center justify-center group-hover:bg-[#004534] transition-colors duration-300">
                    <Icon className="w-6 h-6 text-[#004534] group-hover:text-[#c4e538] transition-colors duration-300" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#004534] mb-1.5">{p.title}</h3>
                    <p className="text-gray-500 text-sm leading-relaxed">{p.text}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
